import {IUploadFileResponse} from './dtos/upload-file-response';
import ApiService from '../../utils/base-api/api-service';
import {IUploadFilesDto} from './dtos/upload-files-dto';

class PictureService extends ApiService {
  constructor() {
    super({
      baseURL: '/AdminPicture',
    });
  }

  asyncUpload(formData: FormData): Promise<IUploadFileResponse> {
    return this.post('/AsyncUpload', formData);
  }

  asyncDelete(fileUrl: Array<string>) {
    return this.post('/AsyncDelete', {
      pictureUrls: fileUrl,
    });
  }

  asyncUploadFiles(formData: FormData): Promise<IUploadFilesDto> {
    return this.post('/AsyncUploadFiles', formData);
  }
}

export const pictureService = new PictureService();
